// ProGate — NEUTRALIZED for the free launch (T2, App Store 3.1.1).
//
// TournyFlex v1 ships FREE with no in-app purchase: every previously
// Pro-gated feature (side games, league creation, big outings, multi-round,
// advanced stats, GHIN posting) is simply OPEN. IAP via StoreKit is a tight
// follow-up, at which point this gate comes back.
//
// Until then this module is an INERT pass-through: it renders no upsell modal,
// steers no one to web payment, and exposes no upgrade surface. The exports
// are kept so existing call sites (EventDraftAdmin uses useProGate) compile
// unchanged — open() is a no-op and element is null, so a gate check that used
// to pop the upsell now silently does nothing and the feature runs.
//
// Do NOT re-introduce web-checkout / upgrade UI here without the StoreKit IAP
// path — reintroducing web-payment steering re-triggers the Apple 3.1.1
// rejection this task removed.

// Kept for API compatibility. With the upsell gone there is nothing to
// remember dismissing, so this is always false.
export function wasDismissedRecently() {
  return false
}

// Inert. Renders nothing — no upsell, no payment steering.
export function ProGateModal() {
  return null
}

// Inert. A gated card no longer needs a lock chip; render nothing.
export function ProLockChip() {
  return null
}

// Inert imperative controller. open()/close() are no-ops and element is null,
// so any legacy `if (needsPro) gate.open(...)` call simply does nothing and
// the underlying feature proceeds for everyone.
export function useProGate() {
  const noop = () => {}
  return { open: noop, close: noop, element: null, wasDismissedRecently }
}
